"use strict";

import axios from '@/plugins/axios';

export const sponsor = {
    namespaced: true,
    state: {
        sponsors: []
    },
    getters: {
        getSponsors: state => state.sponsors
    },
    mutations: {
        UPDATE_SPONSORS: (state, payload) => state.sponsors = payload
    },
    actions: {
        async getSponsors({ commit }) {
            try {
                let res = (await axios.get('/api/sponsors')).data;
                 
                if (res.success) commit('UPDATE_SPONSORS', res.data)

            } catch (error) {
                return error
            }
        },
       
        async createSponsor({ state }, payload) {
            try {
                let res = (await axios.post('/api/sponsors', payload)).data;
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
                if (res.success) { state.sponsors.unshift(res.data); return true }
            } catch (error) {
                return error
            }
        },
        async delete({ state }, payload) {
            try {
                 
                let res = (await axios.delete(`/api/sponsor/${payload.id}`)).data;
                 
                if (res.success) state.sponsors.splice(state.sponsors.findIndex(n => n._id === payload.id), 1)
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error
                 
            }
        },
        async uploadImage(_context, payload) {
            try {
                 
                let res = (
                    await axios.post("api/sponsor/uploadImage", payload, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                ).data;
                if (res.success) return res.data
                else window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error;
            }

        },
    }
}